import React from "react";
import { Marker } from "@react-google-maps/api";
import { GoogleLatLng } from "common/types/google-maps";

// ==============================================================
type Props = {
  centerState?: GoogleLatLng;
  onMarkerRefChange?: (markerRef: google.maps.Marker) => void;
};
// ==============================================================

const component = ({ centerState, onMarkerRefChange }: Props) => {
  return (
    <Marker
      onLoad={onMarkerRefChange}
      onUnmount={onMarkerRefChange}
      icon={{
        size: new google.maps.Size(36, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 21),
        url: "/assets/images/kachi/kachi-map-marker-36x50.png",
      }}
      position={centerState}
    />
  );
};

const KachiMapMarker = React.memo(component);

export default KachiMapMarker;
